import { Action, createReducer, on } from '@ngrx/store';
import { 
    completeConnectionPayment,
    completeConnectionPaymentFailure,
    completeConnectionPaymentSuccess,
    connectCollectMaster,
    connectCollectMasterFailure,
    connectCollectMasterSuccess,
    connectPayment,
    connectPaymentFailure,
    connectPaymentSuccess,
    disconnectCollectMaster,
    disconnectCollectMasterFailure,
    disconnectCollectMasterSuccess,
    disconnectPayment,
    disconnectPaymentFailure,
    disconnectPaymentSuccess,
    getCollectMaster,
    getCollectMasterFailure,
    getCollectMasterSuccess,
    getPayment,
    getPaymentFailure,
    getPaymentSuccess,
    registerPayment,
    registerPaymentFailure,
    registerPaymentSuccess,
    resetState
} from './payment-gateway.action';


export interface PaymentGatewayRecordsState {
    loading: boolean;
    error: any;
    connectUrl: string;
    connectionLoading: boolean;
    collectMasterLoading: boolean;
    hasConnect: boolean|null;
    hasManualConnect: boolean;
    hasCollectMaster: boolean|null;
}

export const initialState: PaymentGatewayRecordsState = {
    loading: false,
    error: null,
    connectUrl: "",
    connectionLoading: false,
    collectMasterLoading: false,
    hasConnect: null,
    hasManualConnect: false,
    hasCollectMaster: null,
};


export const paymentGatewayRecordReducer = createReducer(

    initialState,

    //GET PAYMENT
    on(getPayment, (state) => {
        return { ...state, loading: true, hasConnect: null, hasManualConnect: false, error: null };
    }),
    on(getPaymentSuccess, (state, {hasConnect, hasManualConnect}) => {
        return { ...state, loading: false, hasConnect, hasManualConnect, error: null };
    }),
    on(getPaymentFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    //CONNECTION REQUEST
    on(connectPayment, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(connectPaymentSuccess, (state, { connectUrl, loading }) => {
        return { ...state, connectUrl, loading, error: null };
    }),
    on(connectPaymentFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    //REGISTER REQUEST
    on(registerPayment, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(registerPaymentSuccess, (state, { connectUrl }) => {
        return { ...state, connectUrl, loading: false, error: null };
    }),
    on(registerPaymentFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),
    
    // CONNECTION COMPLETION REQUEST
    on(completeConnectionPayment, (state) => {
        return { ...state, connectionLoading: true, error: null };
    }),
    on(completeConnectionPaymentSuccess, (state) => {
        return { ...state, connectionLoading: false, error: null };
    }),
    on(completeConnectionPaymentFailure, (state, { error }) => {
        return { ...state, error, connectionLoading: false };
    }),

    //GET COLLECT MASTER
    on(getCollectMaster, (state) => {
        return { ...state, loading: true, hasCollectMaster: null, error: null };
    }),
    on(getCollectMasterSuccess, (state, {hasCollectMaster}) => {
        return { ...state, loading: false, hasCollectMaster, error: null };
    }),
    on(getCollectMasterFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    //CONNECTION REQUEST COLLECT MASTER
    on(connectCollectMaster, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(connectCollectMasterSuccess, (state) => {
        return { ...state, loading: false, error: null };
    }),
    on(connectCollectMasterFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),
    
    // Disconnect payment requests
    on(disconnectPayment, (state) => {
        return { ...state, connectionLoading: true, error: null };
    }),
    on(disconnectPaymentSuccess, (state) => {
        return { ...state, connectionLoading: false, error: null };
    }),
    on(disconnectPaymentFailure, (state, { error }) => {
        return { ...state, error, connectionLoading: false };
    }),

    //DISCONNECT REQUEST COLLECT MASTER
    on(disconnectCollectMaster, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(disconnectCollectMasterSuccess, (state) => {
        return { ...state, loading: false, error: null };
    }),
    on(disconnectCollectMasterFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);